<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">Update Quarter</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
            style="width:300px"
          >
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
              <span>Total Entries:</span><span>{{selectedCOGS.length}}</span>
              </p>
              <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
                <span>Total COGS Capped:</span>
                <span>${{totalValues.cogsCapped | thousandSeprator}}</span>
              </p>
              <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
                <span>Total COGS Used:</span>
                <span>${{totalValues.cogsUsed | thousandSeprator}}</span>
              </p>
              <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
                <span>Total COGS Excess:</span>
                <span>${{totalValues.cogsExcess | thousandSeprator}}</span>
              </p>
              <p
                class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
              >
                <span>COGS %:</span>
                <span>{{totalValues.cogsPercent}}%</span>
              </p>
              <!-- <p
                class="pa-0 ma-0 custom-font"
              >Total Amount: ${{totalAmount | thousandSeprator}}</p> -->
            </v-card-subtitle>
          </v-card>
        </v-hover>
        <v-form ref="quarterForm" v-model="valid" lazy-validation v-if="isTopUsers">
          <v-select
            v-model="data.quarter"
            :items="quarters"
            item-value="name"
            item-text="title"
            label="Quarter"
            dense
            outlined
            required
            :rules="MessageRules"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" v-if="isTopUsers">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-dialog>
</template>
<script>
// import campaignAPIs from '../Campaign/campaignAPIs';
// import pairingAPIs from '../Pairing/pairingAPIs';
// // import userAPIs from '../User/userAPIs';
// import campaignConfig from '../Campaign/config';
import config from '@/config';
import { mapState } from 'vuex';
// import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    campaigns: Object,
    selectedCOGS: Array
  },
  data () {
    return {
      valid: true,
      isLoading: false,
      data: {
        quarter: ''
      },
      quarters: [
        // {
        //   name: 'ongoing',
        //   title: 'Ongoing'
        // },
        {
          name: '25Q1',
          title: 'QUARTER 1'
        },
        {
          name: '25Q2',
          title: 'QUARTER 2'
        },
        {
          name: '25Q3',
          title: 'QUARTER 3'
        },
        {
          name: '25Q4',
          title: 'QUARTER 4'
        },
        {
          name: 'na',
          title: 'Others'
        }
      ],
      totalValues: {
        entries: 0,
        cogsCapped: 0,
        cogsUsed: 0,
        cogsExcess: 0,
        cogsPercent: 0
      },
      MessageRules: [value => !!value || 'Required.']
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      savedCampaignCogs: state => state.campaign.savedCampaignCogs,
      campaignUpdated: state => state.campaign.campaignUpdated
    }),
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    isAdmin: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    isTopUsers: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.FINANCE
    }
    // allowedStatuses: function () {
    //   let filtered = this.paymentStatusOptions.filter(option => option.permissions.includes(this.currentUserRole))
    //   return filtered
    // }
  },
  watch: {
    selectedCOGS: function (newselectedCOGS) {
      this.totalValues = {
        entries: 0,
        cogsCapped: 0,
        cogsUsed: 0,
        cogsExcess: 0,
        cogsPercent: 0
      }
      this.totalValues.entries = newselectedCOGS.length
      let totalPercent = 0
      newselectedCOGS.map(ns => {
        this.totalValues.cogsCapped += Number(ns.cappedCOGS)
        this.totalValues.cogsUsed += Number(ns.cogsTotal)
        totalPercent += ns.cogsInfPercentage
      })
      this.totalValues.cogsExcess = this.totalValues.cogsCapped - this.totalValues.cogsUsed
      this.totalValues.cogsPercent = (totalPercent / newselectedCOGS.length).toFixed(2)
      this.totalValues.cogsCapped = this.totalValues.cogsCapped.toFixed(2)
      this.totalValues.cogsUsed = this.totalValues.cogsUsed.toFixed(2)
      this.totalValues.cogsExcess = this.totalValues.cogsExcess.toFixed(2)
      this.totalValues.cogsPercent = this.totalValues.cogsPercent.toFixed(2)
    }
  },
  methods: {
    save() {
      if (!this.$refs.quarterForm.validate()) {
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveCOGS = []
          saveCOGS = this.selectedCOGS.map(s => {
            return {
              id: s.campaignID,
              yearQuarter: this.data.quarter.replace('20', '')
            }
          })
          await this.$store.dispatch('campaign/updateCampaignByIds', saveCOGS)
          this.isLoading = false
          if (this.campaignUpdated) {
            this.$emit('updated')
            this.close()
            this.$swal({
              text: 'Successfully Saved.',
              type: 'success'
            });
          }
        }
      })
    },
    resetForm() {
      this.data = {
        quarter: ''
      }
      this.valid = true
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// UpdateQuarterModal.vue?a11fc486